import React, { useEffect, useState } from 'react';
import Modal from '../../components/Shell/Modal';
import { Button } from '../../components/Button';

import useModal from '../../hooks/useModal';
import usePrevious from '../../hooks/usePrevious';
import useAsync from '../../hooks/useAsync';
import useRequired from '../../hooks/useRequired';

import { addAssets } from '../../api';
import { getModuleFieldsBeta } from '../../api/modules';

import Attributes, { configurePayload } from '../../components/Attributes';

const MODAL_NAME = 'addAssetToOrganization';
const DEFAULT_FORM = {};
const ASSETS_MODULE_ID = process.env.REACT_APP_MODULE_ID_ASSETS;

const AddAssetToOrganizationModal = () => {
	const { open: options, setClose } = useModal(MODAL_NAME);
	const [form, setForm] = useState(DEFAULT_FORM);
	const [updatedForm, setUpdatedForm] = useState({});
	const [additionalFields, setAdditionalFields] = useState([]);

	const {
		value: availableModuleFields,
		execute: onRefreshAvailableModuleFields,
	} = useAsync(getModuleFieldsBeta, {
		immediate: false,
	});

	const {
		value: moduleFields,
		execute: onRefreshModuleFields,
		status: isLoadingModuleFields,
	} = useAsync(getModuleFieldsBeta, {
		immediate: false,
	});

	const { execute: onAddItem } = useAsync(addAssets, {
		immediate: false,
		showNotification: { error: 'raw' },
	});

	/*const { execute: onCreateOrganization } = useAsync(betaCreateOrganization, {
		immediate: false,
		showNotification: {
			error: 'raw',
		},
	});*/

	const prevOpen = usePrevious(options);
	useEffect(() => {
		if (!options && prevOpen) {
			setForm(DEFAULT_FORM);
			setUpdatedForm({});
		}

		if (options && !prevOpen) {
			setForm({ ...DEFAULT_FORM, customer: options?.organization?.value });
			onRefreshModuleFields({
				id: ASSETS_MODULE_ID,
				active: true,
				organizationId: options?.organization?.value,
			});
			onRefreshAvailableModuleFields({
				id: ASSETS_MODULE_ID,
				active: false,
				organizationId: options?.organization?.value,
			});
		}
	}, [options]);

	const availableFields = availableModuleFields?.standard?.filter((x) => {
		return moduleFields?.category?.filter((o) => o.id === x.id).length === 0;
	});

	const hasAllRequiredValues = useRequired(
		{ ...form, ...updatedForm },
		moduleFields?.combined
			?.filter((field) => field.isRequired)
			.map((field) => field.key)
	);

	return (
		<Modal
			title={`Add an asset to ${options?.organization?.label}`}
			name={MODAL_NAME}
			open={options}
			onClose={() => setClose()}
			size="3xl"
		>
			<div className="mt-10 grid grid-cols-1 gap-6 gap-x-8 sm:grid-cols-2">
				{[...(moduleFields?.standard || []), ...(availableFields || [])]
					//	?.filter((field) => skipModuleKeys.indexOf(field.key) === -1)
					?.filter(
						(field) => field?.isActive || additionalFields?.includes(field?.id)
					)
					?.map((field) => (
						<Attributes
							field={field}
							onChange={(index, value, fullValue) => {
								if (value || fullValue) {
									const originalAttribute = form[index];
									let updatedValue = originalAttribute?.value;

									if (fullValue) {
										updatedValue = fullValue;
									} else {
										if (updatedValue && Array.isArray(value)) {
											updatedValue = [
												...(Array.isArray(updatedValue)
													? updatedValue
													: [updatedValue]),
												...value,
											];
										} else {
											updatedValue = value;
										}
									}

									setUpdatedForm({
										...updatedForm,
										[index]: {
											...originalAttribute,
											value: updatedValue,
											fieldId: field.id,
										},
									});
								} else {
									let updated = { ...updatedForm };
									updated[index] = {
										...updated[index],
										value: null,
									};

									if (index === 'category') {
										delete updated['checklist'];
									}

									setUpdatedForm(updated);
								}
							}}
							form={{ ...form, ...updatedForm }}
							updatedForm={updatedForm}
							setForm={setUpdatedForm}
							moduleId={ASSETS_MODULE_ID}
							organizationId={options?.organization?.value}
						/>
					))}

				<div className="flex justify-end col-span-2">
					<Button
						type={hasAllRequiredValues ? 'primary' : 'disabled'}
						disabled={!hasAllRequiredValues || !form?.customer}
						onClick={() =>
							onAddItem(
								{
									...configurePayload(updatedForm, moduleFields?.combined, {
										bucket: 'assets',
									}),
									organizationId: form?.customer,
								},
								(payload) => {
									if (typeof options?.callback === 'function') {
										options?.callback(payload);
									}
									setClose();
								}
							)
						}
					>
						Create & Add
					</Button>
				</div>
			</div>
		</Modal>
	);
};

export default AddAssetToOrganizationModal;
